<template>
  <div class="tips">
    <h5>&emsp;重置成功！</h5>
    <div class="img-box">
      <img class="img" src="@/assets/images/img-set_success.png" alt>
    </div>

    <div class="btn-box">
      <v-button @click="doReturn">
        现在登录
        <span class="counting">{{time}}</span>
      </v-button>
    </div>
  </div>
</template>

<script>
import vButton from "./vButton.vue";

export default {
  components: {
    vButton
  },
  data() {
    return {
      time: 2,
      timer: null
    };
  },
  methods: {
    doReturn() {
      clearInterval(this.timer);
      this.timer = null;
      this.$router.push({ name: "login", query: this.$route.query });
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.time--;
      if (this.time < 1) {
        this.doReturn();
      }
    }, 1000);
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../styles/success.scss";
</style>



// WEBPACK FOOTER //
// src/views/index/components/recoveryS.vue